
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/editorSearch/components/SearchInput/SearchInput.scss.css.virtualfile';
        module.exports = {"inputSuffix":"_inputSuffix_zfinr_1","container":"_container_zfinr_1","clearButton":"_clearButton_zfinr_1","loader":"_loader_zfinr_1"};